import { z } from 'zod';
import { errorMap } from 'zod-validation-error';

import { deepCopy, getErrorKeys, removeKeysFromObject } from '../optionsSchemaUtils';
import { LRSElementOptions } from './LRSElement';

const DISPLAY_MODES = ['full-screen', 'container'] as const;

export const LRSOptionsSchema = z.object({
  paymentId: z.string().trim().min(1),
  paymentToken: z.string().trim().min(1),
  requireAllDocuments: z.boolean().optional(),
  displayMode: z.enum(DISPLAY_MODES).optional()
});

export const parseLRSOptions = (options: LRSElementOptions) => {
  const mandatoryResult = LRSOptionsSchema.safeParse(options, { errorMap });
  const initialOptions = deepCopy(options);

  if (
    !mandatoryResult.success &&
    (mandatoryResult.error.flatten().fieldErrors['paymentId'] ||
      mandatoryResult.error.flatten().fieldErrors['paymentToken'])
  ) {
    return { errors: mandatoryResult.error.errors };
  }

  const errorKeys = getErrorKeys(mandatoryResult.error?.errors || []);
  const sanitizedOptions = removeKeysFromObject(options, errorKeys);

  return !mandatoryResult.success
    ? {
        warnings: mandatoryResult.error.flatten().fieldErrors,
        options: sanitizedOptions as LRSElementOptions,
        initialOptions
      }
    : {
        options: mandatoryResult.data as LRSElementOptions,
        initialOptions
      };
};
